<!--
 * @Author: 田鑫
 * @Date: 2022-03-17 15:34:30
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-03-17 16:42:17
 * @Description: 分类管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康在线</el-breadcrumb-item>
        <el-breadcrumb-item>反馈列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <el-button size="small" type="primary" @click="addItem">
            新增分类
          </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="600" border>
        <el-table-column prop="title" align="center" label="分类名称" />
        <el-table-column prop="" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
            <confirm-button
              type="text"
              style="margin: 0 10px"
              title="确认要删除该条数据？"
              @confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog
      title="分类"
      :visible.sync="dialogVisible"
      width="60%"
      label-width="100px"
      @close="$refs['form'].resetFields()"
    >
      <el-form
        :rules="formRules"
        :model="listParams"
        ref="form"
        label-width="100px"
      >
        <el-form-item label="分类名称：" prop="title">
          <el-input
            placeholder="请输入分类名称"
            v-model="listParams.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类排序：" prop="sort">
          <el-input-number v-model="listParams.sort" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="分类图片：" prop="icon">
          <oss-uploader
            :sizeLimit="2"
            @setImage="getImage"
            :previewList="previewList"
          ></oss-uploader>
        </el-form-item>
        <el-form-item label=" ">
          <div style="text-align: center">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveItem" :disabled="isDisabled"
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogVisible: false,
      formRules: {
        title: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      listParams: {
        id: "",
        title: "",
        sort: "",
        icon: "",
      },
      previewList: [],
      isDisabled: false,
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.loadTableData();
  },
  //生命周期 - 方法
  methods: {
    loadTableData() {
      this.$http({
        url: global.apiUrl + "/advisory/category/list",
        method: "GET",
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data;
            this.pager.total = res.body.data.length;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 新增
     * @param {*}
     * @return {*}
     */
    addItem() {
      this.listParams = this.$options.data().listParams;
      this.listParams.sort = this.tableData.length + 1;
      this.dialogVisible = true;
    },
    /**
     * @description: 编辑
     * @param {*} row
     * @return {*}
     */
    editRow(row) {
      Object.assign(this.listParams, row);
      this.dialogVisible = true;
    },
    /**
     * @description: 删除
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/advisory/category/delete",
        method: "DELETE",
        params: {
          id,
        },
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success("删除成功");
            this.loadTableData();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /**
     * @description: 获取图片
     * @param {*} file
     * @return {*}
     */
    getImage(file) {
      this.listParams.icon = file;
    },
    saveItem() {
      let url;
      let method;
      if (this.listParams.id) {
        url = "/advisory/category/edit";
        method = "PUT";
      } else {
        url = "/advisory/category/add";
        method = "POST";
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.isDisabled = true;
          this.$http({
            url: global.apiUrl + url,
            method,
            body: this.listParams,
          })
            .then((res) => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success("保存成功");
                this.dialogVisible = false;
                this.isDisabled = false;
                this.loadTableData();
              }
            })
            .catch((err) => {
              this.isDisabled = false;
              console.error(err);
            });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
</style>